<script>
    import { select } from 'd3-selection';
    import { scaleTime, scaleBand, scaleOrdinal } from 'd3-scale';
    import { axisTop, axisLeft, axisRight } from 'd3-axis';
    import { timeFormat } from 'd3-time-format';
    import { onMount } from 'svelte';

    export let noticeResults;

    const minDate = new Date(2020, 0);
    const maxDate = new Date(2023, 12);
    const years = [minDate, maxDate];

    var labels = [
        new Date(2020, 6),
        new Date(2021, 6),
        new Date(2022, 6),
        new Date(2023, 6),
    ];

    const margin = {top: 12, right: 2, bottom: 1, left: 54 };
    let width = 200 - margin.left - margin.right;

    // Perhaps map the data to each analyte. If the analyte exists, add it to the analytes list. Then only show that row if it exists. And move the label to the end of the most recent notice.

    /** @type {HTMLDivElement} */
    let chart_container;

    onMount(() => {
        setDimensions();
        drawNotices(); 
    });

    $: drawNotices(noticeResults);

    function setDimensions() {
        width = chart_container.offsetWidth - margin.left -margin.right;
    }

    function drawNotices() {
        let analytesList = noticeResults.map((d) => d.constituent);
        let filteredAnalytes = [...new Set(analytesList)];
        let height = (18*filteredAnalytes.length);

        var container = select(chart_container);
        container.select('svg').remove();
        container.attr('aria-hidden', true);

        // Add Y axis
        const y = scaleBand().domain(filteredAnalytes).range([height, margin.top]).paddingInner(0.2);

        // Add X axis
        const x = scaleTime().domain(years).range([0, width]);

        // Append the svg object to the body of the page
        const svg = container
            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom + 4)
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        svg
            .append('g')
            .attr('class', 'axis y')
            .attr('transform', 'translate(' + 0 + ',' + -2 + ')')
            .call(
                axisLeft(y)
                .tickSize(0)
                );

        // Year labels
        svg
        .append('g')
        .attr('class', 'axis x')
        .call(
            axisTop(x)
            .ticks(4)
            .tickFormat(timeFormat('%Y'))
            .tickSize(0)
            .tickValues(labels)
        );

        let notices = svg
            .selectAll('.notice-marker')
            .data(noticeResults)
            .enter()
            .append('g')
            .attr('class', 'notice-marker');

        notices
            .append('line')
            .attr('stroke', '#793507')
            .attr('stroke-width', 2)
            .attr('x1', function (d) {
                return x(d.start_date) + 5;
            })
            .attr('x2', function (d) {
                return x(d.end_date) - 5;
            })
            .attr('y1', function (d) {
                return y(d.constituent) + y.bandwidth()/filteredAnalytes.length - 1;
            })
            .attr('y2', function (d) {
                return y(d.constituent) - y.bandwidth()/filteredAnalytes.length + 1;
            });

        notices
            .append('line')
            .attr('stroke', '#793507')
            .attr('stroke-width', 2)
            .attr('x1', function (d) {
                return x(d.start_date) + 5;
            })
            .attr('x2', function (d) {
                return x(d.end_date) - 5;
            })
            .attr('y1', function (d) {
                return y(d.constituent) - y.bandwidth()/filteredAnalytes.length + 1;
            })
            .attr('y2', function (d) {
                return y(d.constituent) + y.bandwidth()/filteredAnalytes.length - 1;
            });

            // Year lines
            svg
                .append('g')
                .attr('transform', 'translate(' + 0 + ',' + -margin.top + ')')
                .attr('class', 'axis x year')
                .call(
                    axisTop(x)
                    .ticks(4)
                    .tickFormat('')
                    .tickSize(-height-margin.top)
                    );
    }
</script>

<div id="notices" class="chart" bind:this={chart_container}></div>
